import { render, staticRenderFns } from "./PartnerNoticeCategoryChanger.vue?vue&type=template&id=5d5e30d2&"
import script from "./PartnerNoticeCategoryChanger.vue?vue&type=script&lang=ts&"
export * from "./PartnerNoticeCategoryChanger.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports